var map = {
	"./glitch-preview": 720,
	"./glitch-preview.jpg": 720,
	"./wave-drawer": 721,
	"./wave-drawer-glitched": 722,
	"./wave-drawer-glitched.png": 722,
	"./wave-drawer.png": 721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 831;